export const OPEN_SMALL_DRAWER = 'OPEN_SMALL_DRAWER';
export const CLOSE_SMALL_DRAWER = 'CLOSE_SMALL_DRAWER';
export const CLOSE_ALL_SMALL_DRAWERS = 'CLOSE_ALL_SMALL_DRAWERS';

export const FEED_DRAWER_INFORMATIONS = 'FEED_DRAWER_INFORMATIONS';
export const FEED_DRAWER_MEMBERS = 'FEED_DRAWER_MEMBERS';
export const FEED_DRAWER_GALLERY = 'FEED_DRAWER_GALLERY';
